import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { saveUser as saveUserAction } from '../../../store/ducks/user/actions';
import { Container, NotificationItem, Subtitle } from './styles';
import { ISaveUser } from '../../../store/ducks/user/types';
import { Checkbox, Title } from '@gerdau/hefesto';
import { KeyValueItem } from '@gerdau/hefesto-mais-web';
import { sendTagging } from '../../../store/ducks/tagging/actions';

const Notifications: React.FC = () => {
  const dispatch = useDispatch();

  const userState = useSelector((state: ApplicationState) => state.user);
  const sendOrdersToEmail = useSelector(
    (state: ApplicationState) => state.user.sendOrdersToEmail
  );
  const sendFinancialToEmail = useSelector(
    (state: ApplicationState) => state.user.sendFinancialToEmail
  );
  const userAcceptNotification = useSelector(
    (state: ApplicationState) => state.user.terms.userAcceptNotification
  );

  const saveUser = (
    newSendOrdersToEmail: boolean,
    newSendFinancialToEmail: boolean,
    newUserAcceptNotification: boolean
  ) => {
    const saveUserProps: ISaveUser = {
      user: userState,
      sendOrdersToEmail: newSendOrdersToEmail,
      sendFinancialToEmail: newSendFinancialToEmail,
      userAcceptNotification: newUserAcceptNotification
    };
    dispatch(saveUserAction(saveUserProps));
  };

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: 'LG:Configuracoes:Notificacoes',
        page: window.location.pathname,
        event: 'page_view'
      })
    );
  }, []);

  const prepareAndSendTagging = (itemName: string, itemDescription: string) => {
    dispatch(
      sendTagging({
        screenName: 'LG:Configuracoes:Notificacoes',
        itemName,
        itemDescription,
        event: 'click'
      })
    );
  };

  return (
    <Container>
      <div data-testid="new-title-notifications">
        <Title level={2}>Notificações novas</Title>
        <Subtitle>
          Nessa página, você pode configurar as notificações que você deseja
          receber por email:
        </Subtitle>
      </div>

      <div>
        {userState.userPermissions.hasOrderViewAccess && (
          <NotificationItem>
            <KeyValueItem
              title={'Recebimento da carteira de pedidos'}
              titleLevel={4}
            >
              Recebimento diário da carteira de pedidos por e-mail
            </KeyValueItem>
            <Checkbox
              name="orders-to-email"
              checked={sendOrdersToEmail}
              onChange={() => {
                saveUser(
                  !sendOrdersToEmail,
                  sendFinancialToEmail,
                  userAcceptNotification
                );
                prepareAndSendTagging(
                  sendOrdersToEmail
                    ? 'check_box:recebimento_carteira_pedidos_off'
                    : 'check_box:recebimento_carteira_pedidos_on',
                  sendOrdersToEmail
                    ? 'configuracoes_notificacoes_recebimentoCarteiraPedidosOff'
                    : 'configuracoes_notificacoes_recebimentoCarteiraPedidosOn'
                );
              }}
            />
          </NotificationItem>
        )}

        {userState.userPermissions.hasFinancialAccess && (
          <NotificationItem>
            <KeyValueItem
              title={'Vencimento do limite de crédito'}
              titleLevel={4}
            >
              Recebimento de alerta quando seu limite de crédito estiver prestes
              a vencer
            </KeyValueItem>
            <Checkbox
              name={'financial-to-email'}
              checked={sendFinancialToEmail}
              onChange={() => {
                saveUser(
                  sendOrdersToEmail,
                  !sendFinancialToEmail,
                  userAcceptNotification
                );
                prepareAndSendTagging(
                  sendFinancialToEmail
                    ? 'check_box:vencimento_limite_credito_off'
                    : 'check_box:vencimento_limite_credito_on',
                  sendFinancialToEmail
                    ? 'configuracoes_notificacoes_vencimentoLimiteCreditoOff'
                    : 'configuracoes_notificacoes_vencimentoLimiteCreditoOn'
                );
              }}
            />
          </NotificationItem>
        )}
      </div>
    </Container>
  );
};

export default Notifications;
